import {ITag, ITagData, ITagLabel, ITagLabelData, TagType, TagValue, TAG_REPRESENTATION_MAX_LABELS} from './index'
import {CriterionName, ICriterion} from "@/entities";
import {rangeLabel} from '@/lib'

export class TagLabel implements ITagLabel {
  label: string
  remainder: number

  constructor(data: ITagLabelData) {
    this.label = data.label
    this.remainder = data.remainder || 0
  }
}

export class Tag implements ITag {

  name: string
  value: TagValue
  type: TagType

  constructor(data: ITagData) {
    this.name = data.name
    let value = data.value
    let type = data.type
    this.type = type ? type : Tag.parseTagType(value)
    this.value = value
  }

  private static parseTagType(value: TagValue): TagType {
    switch (typeof value) {
      case 'number':
      case 'string': {
        return 'value'
      }
      case 'object': {
        if (value[0]?.hasOwnProperty('name')) {
          return 'criterion'
        } else {
          return 'range'
        }
      }
      default: {
        return ''
      }
    }
  }

  private getRangeLabel(): string {
    let from = (this.value as any)[0];
    let to = (this.value as any)[1];
    return rangeLabel(from, to);
  }

  private static representationPart(item: ICriterion<CriterionName>, index: number): string {
    return (index === 0 ? '' : ', ') + item.name;
  }

  private get criterionLabel(): ITagLabelData {
    return {
      label: (this.value as ICriterion<CriterionName>[]).map(item => item.name).join(', ')
    };
  }

  private get shortCriterionLabel(): ITagLabelData {
    let label = '';
    let value = this.value as ICriterion<CriterionName>[];
    for (let i = 0; i < TAG_REPRESENTATION_MAX_LABELS; i++) {
      label += Tag.representationPart(value[i], i);
    }

    let len = value.length;
    return {
      label: label,
      remainder: (len > TAG_REPRESENTATION_MAX_LABELS) ? len - TAG_REPRESENTATION_MAX_LABELS : 0
    }
  }

  private abstractRepresentation(short: boolean = false): TagLabel {
    let res: ITagLabelData;
    switch (this.type) {
      case 'range':
        res = {
          label: this.getRangeLabel()
        }; break
      case 'value':
        res = {
          label: this.value  + ''
        }; break
      case 'criterion':
        res = short
          ? this.shortCriterionLabel
          : this.criterionLabel; break
      default:
        res = {
          label: ''
        };
    }
    return new TagLabel(res);
  }

  get shortRepresentation(): TagLabel {
    return this.abstractRepresentation(true);
  }

  get representation(): TagLabel {
    return this.abstractRepresentation();
  }
}